import { createContext } from 'react';
import { TaskItems } from '../../../shared/types/types';
import { pendingTaskItems } from '../../../utils/tasks/tasksUtils';

const TaskItemsContext = createContext<TaskItems>(pendingTaskItems);

export default TaskItemsContext;
